module.exports = __webpack_public_path__ + "assets/95b224bf44d928b4b696b00422202b00.jpg";